export default __webpack_public_path__ + "static/media/icon-home.fc5fa498.svg";